/**
 * Tokens semánticos del Toggle según diseño de Figma
 *
 * El componente usa clases semánticas de Tailwind configuradas con variables CSS de Figma:
 *
 * COLORES (tokens semánticos):
 * - Activo: ui-bg-fill-brand → var(--ui-color-bg-fill-brand-default) = #3658c1
 * - Inactivo: ui-bg-fill-brand-disabled → var(--ui-color-bg-fill-brand-disabled) = #b8c5ee
 * - Disabled: ui-bg-fill-hover → var(--ui-color-bg-fill-hover) = #f0f1f2
 * - Border: ui-border-DEFAULT → var(--ui-color-border-default) = #c6c8cc
 * - Thumb: ui-bg-fill = #ffffff
 * - Text: ui-text-primary → var(--ui-color-text-primary) = #313336
 *
 * DIMENSIONES (clases de Tailwind con Positive Space):
 * - Container width: ui-w-32 → var(--ui-Positive-space_32) = 32px
 * - Container height: ui-h-20 → var(--ui-Positive-space_20) = 20px
 * - Thumb: ui-w-16 ui-h-16 → var(--ui-Positive-space_16) = 16px
 * - Padding: ui-px-2 → var(--ui-Positive-space_2) = 2px
 * - Gap: ui-gap-8 → var(--ui-Positive-space_8) = 8px
 * - Border radius: ui-rounded-2xl = 16px
 */
export const TOGGLE_DESIGN_TOKENS = {
  // Clases semánticas de color (background)
  colors: {
    active: 'ui-bg-fill-brand',
    inactive: 'ui-bg-fill-brand-disabled',
    disabled: 'ui-bg-fill-hover',
    border: 'ui-border-DEFAULT',
    thumb: 'ui-bg-fill',
    text: 'ui-text-primary',
  },
  // Primitivas de tamaño (clases de Tailwind configuradas con Positive Space)
  size: {
    containerWidth: 'ui-w-32', // var(--ui-Positive-space_32) = 32px
    containerHeight: 'ui-h-20', // var(--ui-Positive-space_20) = 20px
    thumbSize: 'ui-w-16 ui-h-16', // var(--ui-Positive-space_16) = 16px
    padding: 'ui-px-2', // var(--ui-Positive-space_2) = 2px
    borderRadius: 'ui-rounded-2xl', // 16px
  },
  // Espaciado (clases de Tailwind con Positive Space)
  spacing: {
    gap: 'ui-gap-8', // var(--ui-Positive-space_8) = 8px
  },
  // Tipografía (según Type/Body/SM/Bold de Figma)
  typography: {
    weight: 'ui-font-body-sm-bold',
    size: 'ui-text-body-sm-bold',
    lineHeight: 'ui-leading-[20.5px]',
    tracking: 'ui-tracking-[0.5px]',
  },
} as const;
